import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const TABS = ['众议院', '参议院', '州长'];
const SELECTED_ICON = 'https://x0.ifengimg.com/ucms/2026_43/6AE92D790D09C1FC9C7070BDBC20173173A16F51_size1_w40_h28.png';

const Tabs = ({ current = 0, onChange }) => {
    return (
        <div className={styles.wrap}>
            {TABS.map((label, index) => {
                const selected = index === current;

                return (
                    <div key={label} className={selected ? styles.tabSelected : styles.tab} onClick={() => onChange(index)}>
                        {selected ? <img className={styles.icon} src={SELECTED_ICON} alt="" /> : null}
                        <span>{label}</span>
                    </div>
                );
            })}
        </div>
    );
};

Tabs.propTypes = {
    current: PropTypes.number,
    onChange: PropTypes.func,
};

export default errorBoundary(Tabs);
